import axios from 'axios';
import { SERVER_ENDPOINT, CLIENT_ID, CLIENT_SECRET } from '../Constants';

function getUserAddresses(token, id) {
  const url = 'api/user/' + id + '/addresses/';
  return axios({
    method: 'get',
    url,
    baseURL: SERVER_ENDPOINT,
    timeout: '10000',
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json',
      authorization: 'Bearer ' + token,
    },
    data: {
      client_id: CLIENT_ID,
      client_secret: CLIENT_SECRET,
    },
  });
}

function createAddress(
  token,
  id,
  addressFName,
  addressLName,
  addressLine1,
  addressLine2,
  addressCity,
  addressState,
  addressZip,
  addressCountry,
  addressPhone,
  defaultAddress,
) {
  const url = 'api/accounts/addresses/';
  return axios({
    method: 'post',
    url,
    baseURL: SERVER_ENDPOINT,
    timeout: '10000',
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json',
      authorization: 'Bearer ' + token,
    },
    data: {
      user: id,
      client_id: CLIENT_ID,
      client_secret: CLIENT_SECRET,
      first_name: addressFName,
      last_name: addressLName,
      line1: addressLine1,
      line2: addressLine2,
      line4: addressCity,
      state: addressState,
      postcode: addressZip,
      country: addressCountry,
      phonenumber: addressPhone,
      is_default_for_billing: false,
      is_default_for_shipping: defaultAddress,
    },
  });
}

function updateAddress(
  token,
  id,
  addressId,
  addressFName,
  addressLName,
  addressLine1,
  addressLine2,
  addressCity,
  addressState,
  addressZip,
  addressCountry,
  addressPhone,
  defaultAddress,
) {
  const url = 'api/accounts/addresses/' + addressId + '/';
  return axios({
    method: 'put',
    url,
    baseURL: SERVER_ENDPOINT,
    timeout: '10000',
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json',
      authorization: 'Bearer ' + token,
    },
    data: {
      user: id,
      client_id: CLIENT_ID,
      client_secret: CLIENT_SECRET,
      first_name: addressFName,
      last_name: addressLName,
      line1: addressLine1,
      line2: addressLine2,
      line4: addressCity,
      state: addressState,
      postcode: addressZip,
      country: addressCountry,
      phonenumber: addressPhone,
      is_default_for_billing: false,
      is_default_for_shipping: defaultAddress,
    },
  });
}

function deleteAddress(token, addressId) {
  const url = 'api/accounts/addresses/' + addressId + '/';
  return axios({
    method: 'delete',
    url,
    baseURL: SERVER_ENDPOINT,
    timeout: '10000',
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json',
      authorization: 'Bearer ' + token,
    },
    data: {
      client_id: CLIENT_ID,
      client_secret: CLIENT_SECRET,
    },
  });
}

export {
  getUserAddresses,
  createAddress,
  updateAddress,
  deleteAddress,
};
